import PropTypes from 'prop-types';
import { CustomSelect } from './CustomSelect.js';

const OPTIONS = [
  { value: 'Auteur', label: 'Auteur' },
  { value: 'Afig', label: 'Auteur de la source figurée' },
  { value: 'AtelierEcole', label: 'Atelier ou école' },
  { value: 'Personnalite', label: 'Personnalité' },
];

const AuteurQualiteField = ({ name, defaultValue, onChange }) => (
  <CustomSelect
    className="critere-input"
    value={defaultValue || null}
    name={name}
    onChange={onChange}
    options={OPTIONS}
  />
);
AuteurQualiteField.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({
    valeur: PropTypes.string,
    label: PropTypes.string,
    operateur: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default AuteurQualiteField;
